import React, { forwardRef } from 'react'

import BaseText from '../BaseText'
import { StringOnlyExportTextProps } from '../BaseText/types'

const MetaText: React.FC<StringOnlyExportTextProps> = forwardRef(({ Tag = 'span', ...props }) => (
  <BaseText Tag={Tag} size="meta" {...props} />
))

export default MetaText
